<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">卫生打卡<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="打卡时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
            <div class="content-input-item">
              <!--              <label>客户搜索</label>-->
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>

            <div class="content-input-item">
              <label>打卡类型</label>
              <el-select v-model="type" placeholder="Select" class="select-item">
                <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>上传状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-space>
              <el-badge is-dot :hidden="needAuditNum == 0" v-if="(operateState & 32) == 32">
                <el-button type="warning" @click="buttonTypeChange(2, true)">待审核<span v-if="needAuditNum > 0">（{{needAuditNum}}）</span></el-button>
              </el-badge>
              <el-badge is-dot :hidden="needUploadNum == 0" v-else>
                <el-button type="warning" @click="buttonTypeChange(1, true)">需上传<span v-if="needUploadNum > 0">（{{needUploadNum}}）</span></el-button>
              </el-badge>
              <el-divider direction="vertical"></el-divider>
              <el-button @click="checkDetailList(0, 4, shopId)">非常干净</el-button>
              <el-button @click="checkDetailList(0, 3, shopId)">干净</el-button>
              <el-button @click="checkDetailList(0, 2, shopId)">一般<span v-if="generalNum > 0">（{{generalNum}}）</span></el-button>
              <el-button @click="checkDetailList(0, 1, shopId)">不合格<span v-if="notCleanNum > 0">（{{notCleanNum}}）</span></el-button>
            </el-space>
          </div>
          <div style="display: flex;align-items: center;">
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="startDate" label="打卡时间" v-if="checkColList.indexOf('打卡时间') > -1" width="200">
              <template #default="scope">
                <p>{{scope.row.startDate}}<span v-if="scope.row.endDate != scope.row.startDate">~{{scope.row.endDate}}</span></p>
              </template>
            </el-table-column>
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"/>

            <el-table-column property="" label="卫生打卡类型" v-if="checkColList.indexOf('卫生打卡类型') > -1" width="140">
              <template #default="scope">
                {{scope.row.type == 1?'每日卫生打卡':scope.row.type == 2?'每周卫生打卡':scope.row.type == 3?'每月卫生打卡':'' }}
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="清洁位置" v-if="checkColList.indexOf('清洁位置') > -1" width="280">
              <template #default="scope">
                <el-space wrap v-if="scope.row.detailList">
                  <el-tag v-for="(item,index) in scope.row.detailList" :key="index">{{item.area}}（{{item.location}}）</el-tag>
                </el-space>
              </template>
            </el-table-column>
            <el-table-column property="" label="非常干净" v-if="checkColList.indexOf('非常干净') > -1">
              <template #default="scope">
                  <el-button type="text" v-if="scope.row.veryCleanNum > 0" @click="checkDetailList(scope.row.id, 4, scope.row.shopId)">{{scope.row.veryCleanNum}}</el-button>
                  <span v-else>{{scope.row.veryCleanNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="干净" v-if="checkColList.indexOf('干净') > -1">
              <template #default="scope">
                <el-button type="text" v-if="scope.row.cleanNum > 0" @click="checkDetailList(scope.row.id, 3, scope.row.shopId)">{{scope.row.cleanNum}}</el-button>
                <span v-else>{{scope.row.cleanNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="一般" v-if="checkColList.indexOf('一般') > -1">
              <template #default="scope">
                <el-button type="text" v-if="scope.row.generalNum > 0" @click="checkDetailList(scope.row.id, 2, scope.row.shopId)">{{scope.row.generalNum}}</el-button>
                <span v-else>{{scope.row.generalNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="不合格" v-if="checkColList.indexOf('不合格') > -1">
              <template #default="scope">
                <el-button type="text" v-if="scope.row.notCleanNum > 0" @click="checkDetailList(scope.row.id, 1, scope.row.shopId)">{{scope.row.notCleanNum}}</el-button>
                <span v-else>{{scope.row.notCleanNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="上传状态" v-if="checkColList.indexOf('上传状态') > -1" >
              <template #default="scope">
                {{scope.row.state == 0?'未上传':scope.row.state == 1?'已上传':scope.row.state == 2?'已超时':''}}
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="110">
              <template #default="scope">
                <el-button @click="checkDetail(scope.row.id, -1, scope.row, scope.$index)" size="small" type="primary" :disabled="scope.row.state == 2">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; justify-content: space-between">
            <el-table
                :data="sumDataList"
                style="width: 70%; margin-top: 20px;"
                v-loading="listLoading"
                size="default"
                border
            >
              <el-table-column property="" label="汇总" width="80"></el-table-column>
              <el-table-column property="" label="卫生打卡类型" width="140">
                <template #default="scope">
                  {{scope.row.type == 1?'每日卫生打卡':scope.row.type == 2?'每周卫生打卡':scope.row.type == 3?'每月卫生打卡':'' }}
                </template>
              </el-table-column>
              <el-table-column property="uploadNum" label="已上传数"></el-table-column>
              <el-table-column property="needUploadNum" label="未上传数"></el-table-column>
              <el-table-column property="overtimeNum" label="超时未上传数"></el-table-column>
              <el-table-column property="veryCleanNum" label="非常干净"></el-table-column>
              <el-table-column property="cleanNum" label="干净"></el-table-column>
              <el-table-column property="generalNum" label="一般"></el-table-column>
              <el-table-column property="notCleanNum" label="不合格"></el-table-column>
            </el-table>
            <div>
              <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData,imgPostFormData } from "@/api/api";
import {
  getHygienePageList,
  getHygienePageSummary,
  hygieneStatStateNum,
  getHygieneDetailPageList
} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemark from "@/components/Remark/UserRemark";
import UserLogList from "@/components/UserLogList/UserLogList";
import UserInfo from "@/components/User/userInfo"
import ConsumeList from "@/views/user/components/ConsumeList";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange_7_1";
import userInfoDialog from "@/components/User/userInfoDialog";
import PetListDialog from "@/views/user/components/PetListDialog";
import hygieneDetailDialog from "@/views/hygiene/components/hygieneDetailDialog";

export default {
  name: "HygieneIndex",
  components: { BtnGroup, SearchComponents, UserRemark, UserInfo, ConsumeList, UserLogList, unLock, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      batchLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      typeArray: [
        {label: '不限', value: -1},
        {label: '每日卫生打卡', value: 1},
        {label: '每周卫生打卡', value: 2},
        {label: '每月卫生打卡', value: 3},
      ],
      type: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未上传', value: 0},
        {label: '已上传', value: 1},
        {label: '已超时', value: 2},
      ],
      state: -1,



      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //刷新组
      colList: ['打卡时间', '所属门店', '卫生打卡类型', '清洁位置', '非常干净', '干净', '一般', '不合格','上传状态', '超时状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '区域', value : 1},
        {label : '位置', value : 2},
        // {label : '宠物昵称', value : 3},
      ],
      searchType: 1,
      searchValue: '',
      limitState: false,

      upUserLoading: false,
      upPetLoading: false,

      buttonType: -1,

      idArray: [],

      uploadImgId: 0,

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

      needUploadNum: 0,
      needAuditNum: 0,
      generalNum: 0,
      notCleanNum: 0,

    }
  },
  methods: {

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        confirm: () => {
        }
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '回访图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.visitImgList,
          id: row.id,
          width: 908,
          from: 4,
          hideBtn: (this.operateState & 2)  == 2 || row.recheckState == 5 || row.recheckState == 6
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.shopId = 0;
      this.type = -1;
      this.state = -1;
      this.buttonType = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    buttonTypeChange(state,reset) {
      this.buttonType = state
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;

        let param = {};
        param['pageNum'] = this.currentPage;
        param['shopId'] = this.shopId;
        param['type'] = -1;
        param['state'] = -1;
        param['buttonType'] = this.buttonType;
        param['searchType'] = 1;
        param['searchValue'] = '';
        param['limitState'] = 0;
        param['startTime'] = '';
        param['endTime'] = '';

        this.sendPageReq(param);
      }
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      if(this.buttonType == -1) {
        this.getPage();
      }else {
        this.buttonTypeChange(this.buttonType)
      }
    },


    getPage(reset) {
      this.buttonType = -1
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          // this.buttonType = -1
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['type'] = this.type;
      param['state'] = this.state;
      param['buttonType'] = this.buttonType;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getHygienePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.pageDataList.map(item => {
            item.veryCleanNum = 0
            item.cleanNum = 0
            item.generalNum = 0
            item.notCleanNum = 0
            item.detailList.map(obj => {
                if(obj.result == 1)item.notCleanNum ++
                if(obj.result == 2)item.generalNum ++
                if(obj.result == 3)item.cleanNum ++
                if(obj.result == 4)item.veryCleanNum ++
            })
          })
          this.getSumPage(param)
          this.getStatNum()
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getSumPage(param) {
      getFormData(getHygienePageSummary, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.sumDataList = []
          for(let i=1; i<=3; i++) {
            let obj = {
              type: i,
              uploadNum:0,
              needUploadNum:0,
              overtimeNum:0,
              veryCleanNum:0,
              cleanNum:0,
              generalNum:0,
              notCleanNum:0,
            }
            this.sumDataList.push(obj)
          }
          let detailSummaryList = data['data'].detailSummaryList
          let hygieneSummaryList = data['data'].hygieneSummaryList
          for(let j=0; j<this.sumDataList.length; j++) {
            detailSummaryList.map(item => {
              if(item.type == this.sumDataList[j].type) {
                  this.sumDataList[j].veryCleanNum = item.veryCleanNum
                  this.sumDataList[j].cleanNum = item.cleanNum
                  this.sumDataList[j].generalNum = item.generalNum
                  this.sumDataList[j].notCleanNum = item.notCleanNum
              }
            })
            hygieneSummaryList.map(item => {
              if(item.type == this.sumDataList[j].type) {
                  this.sumDataList[j].uploadNum = item.uploadNum
                  this.sumDataList[j].needUploadNum = item.needUploadNum
                  this.sumDataList[j].overtimeNum = item.overtimeNum
              }
            })
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
          .catch((response) => {
          })
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

    },

    getStatNum() {
      getFormData(hygieneStatStateNum, {shopId: this.shopId}).then(data => {
          this.needUploadNum = 0
          this.needAuditNum = 0
          this.generalNum = 0
          this.notCleanNum = 0
          this.needUploadNum = data.data.needUploadNum
          this.needAuditNum = data.data.needAuditNum
          this.generalNum = data.data.detailStatStateNum?data.data.detailStatStateNum.generalNum:0
          this.notCleanNum = data.data.detailStatStateNum?data.data.detailStatStateNum.notCleanNum:0
      })
    },

    checkDetail(hygieneId, result, row, idx) {
      if(row.state == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请先前往小程序上传清洁照片',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '打卡详情',
        component: hygieneDetailDialog,
        data: {
          hygieneId: hygieneId,
          result: result,
          shopId: row.shopId,
          showOperate: true,
          width: '1100px'
        },
        close: () => {
          this.getHygieneById(row, idx)
          this.getStatNum()
        }
      })
    },

    getHygieneById(row, idx) {
      let param = {};
      param['pageNum'] = 1;
      param['hygieneId'] = row.id;
      param['result'] = -1;
      param['type'] = -1;
      param['shopId'] = row.shopId;
      getFormData(getHygieneDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          let dataList = result['records'];
          this.pageDataList[idx].notCleanNum = 0
          this.pageDataList[idx].generalNum = 0
          this.pageDataList[idx].cleanNum = 0
          this.pageDataList[idx].veryCleanNum = 0
          dataList.map(obj => {
            if(obj.result == 1)this.pageDataList[idx].notCleanNum ++
            if(obj.result == 2)this.pageDataList[idx].generalNum ++
            if(obj.result == 3)this.pageDataList[idx].cleanNum ++
            if(obj.result == 4)this.pageDataList[idx].veryCleanNum ++
          })
          // this.pageDataList[idx].detailList = dataList
        }
      })
    },

    checkDetailList(hygieneId, result, shopId) {
      Dialog.open({
        title: '打卡详情',
        component: hygieneDetailDialog,
        data: {
          hygieneId: hygieneId,
          result: result,
          shopId: shopId,
          width: '1100px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })

    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
}
</style>
